
import {ACTION} from './constants';


let initialState={isLoading: false};

export default function navDividendReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION.GET_NAV_CONTENT :
            return {...state, nav:{...action.data, searchQuery:'', apiLoaded: true}};

        case ACTION.GET_DIVIDEND_CONTENT :
            return {...state,  dividend:{...action.data, searchQuery:'', apiLoaded: true}};

        case ACTION.GET_NAV_SEARCH_CONTENT :
            return {...state, nav:{...state.nav,latest:[{schemes:action.data}], searchQuery:action.query}};

        case ACTION.GET_DIVIDEND_SEARCH_CONTENT :
            return {...state, dividend:{...state.dividend,latest:[{schemes:action.data}],searchQuery:action.query}};

        case ACTION.GET_NAV_FUND_FILTER :
            return {...state, fundFilter:action.data};

        case ACTION.GET_HISTORIC_DATA_NAV :
            return {...state, nav:{...state.nav,historic:[{schemes:action.data}]},isLoading:false};

        case ACTION.GET_HISTORIC_DATA_DIVIDEND :
            return {...state, dividend:{...state.dividend,historic:[{schemes:action.data}]},isLoading:false};

        case ACTION.GET_HISTORIC_DATA_LOADING:
            return {...state, isLoading: true};




        default:
            return state;
    }
}

